export const getThemeLink = (partnername: string, customname: string) =>
  partnername &&
  customname &&
  `/${String(partnername)}/${String(customname)}-config.json`;
